<template>
  <VView class="contest-personal" :header="$t('contestPersonal.header')">
    <VForm ref="form"
      :fields="fields"
      @update="onFormUpdate($event)"
    />

    <VBlock max-width="300px">
      <transition name="bounceUp" appear>
        <VButton @click="next()">{{ $t('contestPersonal.next') }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
import { mapState } from 'vuex';
import { SET_PERSONAL_FIELD } from '@/store';
import {
  FIELD_TYPE_TEXT,
  FIELD_TYPE_EMAIL,
  FIELD_TYPE_COMMENT,
} from '@/components/VForm.vue';

export default {
  name: 'ContestPersonal',

  computed: {
    ...mapState({
      fields(state) {
        return [
          {
            key: 'childData',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestPersonal.childData'),
            width: '100%',
          },
          {
            key: 'childFirstName',
            type: FIELD_TYPE_TEXT,
            isRequired: true,
            label: this.$t('contestPersonal.childFirstName'),
            value: state.personal.childFirstName,
            width: '50%',
          },
          {
            key: 'childLastName',
            type: FIELD_TYPE_TEXT,
            isRequired: true,
            label: this.$t('contestPersonal.childLastName'),
            value: state.personal.childLastName,
            width: '50%',
          },
          {
            key: 'parentData',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestPersonal.parentData'),
            width: '100%',
          },
          {
            key: 'firstName',
            type: FIELD_TYPE_TEXT,
            isRequired: true,
            label: this.$t('contestPersonal.firstName'),
            value: state.personal.firstName,
            width: '50%',
          },
          {
            key: 'lastName',
            type: FIELD_TYPE_TEXT,
            isRequired: true,
            label: this.$t('contestPersonal.lastName'),
            value: state.personal.lastName,
            width: '50%',
          },
          {
            key: 'email',
            type: FIELD_TYPE_EMAIL,
            isRequired: true,
            label: this.$t('contestPersonal.email'),
            value: state.personal.email,
            width: '50%',
          },
          {
            key: 'phone',
            type: FIELD_TYPE_TEXT,
            isRequired: true,
            label: this.$t('contestPersonal.phone'),
            value: state.personal.phone,
            width: '50%',
          },
          {
            key: 'reminder',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestPersonal.reminder'),
            width: '100%',
          },
          {
            key: 'required',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestPersonal.required'),
            width: '100%',
          },
        ];
      },
    }),
  },

  methods: {
    onFormUpdate({ key, value }) {
      this.$store.commit(SET_PERSONAL_FIELD, { key, value });
    },

    async next() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        return;
      }

      this.$router.push('/contest/legals');
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-personal {}
</style>
